"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIRouterLink;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _AbstractRouterLink = _interopRequireDefault(require("./internal/AbstractRouterLink"));

function UIRouterLink(props) {
  return _react.default.createElement(_AbstractRouterLink.default, (0, _extends2.default)({}, props, {
    component: _UILink.default
  }));
}

var _AbstractRouterLink$p = _AbstractRouterLink.default.propTypes,
    __ = _AbstractRouterLink$p.component,
    sanitizedAbstractRouterLinkPropTypes = (0, _objectWithoutProperties2.default)(_AbstractRouterLink$p, ["component"]);
UIRouterLink.propTypes = (0, _extends2.default)({}, sanitizedAbstractRouterLinkPropTypes, _UILink.default.propTypes);
UIRouterLink.defaultProps = (0, _extends2.default)({}, _UILink.default.defaultProps);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-react-router-dom/static-1.2601/js/UIRouterLink.js
// module id = 78
// module chunks = 209 210 211 212